import { render, staticRenderFns } from "./AvailableDevicesList.vue?vue&type=template&id=20867e7f&scoped=true&"
import script from "./AvailableDevicesList.vue?vue&type=script&lang=ts&"
export * from "./AvailableDevicesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20867e7f",
  null
  
)

export default component.exports